import React, { FC } from 'react';
import { Button, Grid } from '@material-ui/core';

const DeviceManageButtons: FC<{ handleClick: (name: string) => void }> = ({ handleClick }) => {
    return (
      <>
      <Grid item xs={12}>
        <Button onClick={() => handleClick('kørt')} fullWidth variant="contained" color="primary">
          Genstart kort/mønt
        </Button>
        </Grid>
        <Grid item xs={12}>
        <Button onClick={() => handleClick('printer')} fullWidth variant="contained" color="primary">
          Genstart printer
        </Button>
        </Grid>
        <Grid item xs={12}>
        <Button onClick={() => handleClick('restart')} fullWidth variant="contained" color="primary">
          Genstart automat
        </Button>
        </Grid>
      </>
    );
  };

  export default DeviceManageButtons;


  